// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zDoSx82ndoVLwi5Ug71M{border:1px solid var(--interaction-neutral-normal);border-radius:12px;grid-template-columns:max-content 1fr max-content;width:100%;padding:15px 14px 24px;display:grid}.Ky1R5Qqt1k_ucZvmzPpo{padding-left:12px;padding-right:16px}.Ky1R5Qqt1k_ucZvmzPpo .AAKJkoO0hLM6ayYQNbop{flex-direction:column;gap:8px;display:flex}.Ky1R5Qqt1k_ucZvmzPpo .F3OcDvdMJoVk0hmyWFrM{margin-top:16px;position:relative}.s5cn8F1pQ0iYdkjiFKAq{border-top:1px solid var(--border-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zDoSx82ndoVLwi5Ug71M`,
	"center": `Ky1R5Qqt1k_ucZvmzPpo`,
	"info": `AAKJkoO0hLM6ayYQNbop`,
	"select": `F3OcDvdMJoVk0hmyWFrM`,
	"searchInput": `s5cn8F1pQ0iYdkjiFKAq`
};
export default ___CSS_LOADER_EXPORT___;
